// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SMDTz","clinicsSelect":"styles_clinicsSelect__GzMkO"};